export const PROFESIONES = {
  'Enfermero/a': 1,
  Fisioterapeuta: 2,
  'Médico/a': 3,
  Administración: 4,
  Otro: 0,
};

const PROFESION_LABELS = {
  0: 'Otro',
  1: 'Enfermero/a',
  2: 'Fisioterapeuta',
  3: 'Médico/a',
  4: 'Administración',
};

export const getProfesionLabel = (value) => PROFESION_LABELS[value] || '';

export const getProfesionValue = (label) => PROFESIONES[label] || 0;

export const ROLES = {
  SUPERADMIN: 'Administrador total',
  ADMIN: 'Administrador',
  SANITARIO: 'Sanitario',
};

export const getRoleLabel = (role) => ROLES[role] || role || '';

/**
 * Permisos por defecto de cada rol.
 * Debe mantenerse alineado con src/auth/permissions.ts del servidor.
 */
export const ROLE_DEFAULT_PERMISSIONS = {
  SUPERADMIN: [
    'pacientes:read', 'pacientes:create', 'pacientes:update', 'pacientes:delete',
    'pruebas:read', 'pruebas:create', 'pruebas:update', 'pruebas:delete',
    'datos:export', 'datos:import',
    'users:read', 'users:create', 'users:update', 'users:activate',
    'users:manage_permissions', 'users:manage_admins',
  ],
  ADMIN: [
    'pacientes:read', 'pacientes:create', 'pacientes:update', 'pacientes:delete',
    'pruebas:read', 'pruebas:create', 'pruebas:update', 'pruebas:delete',
    'datos:export', 'datos:import',
    'users:read', 'users:create', 'users:update', 'users:activate',
  ],
  SANITARIO: [
    'pacientes:read', 'pacientes:create', 'pacientes:update',
    'pruebas:read', 'pruebas:create', 'pruebas:update',
  ],
};

/**
 * Catálogo de permisos agrupado por módulo, con etiquetas en castellano.
 * Debe mantenerse alineado con src/auth/permissions.ts del servidor.
 */
export const PERMISSION_GROUPS = [
  {
    module: 'Pacientes',
    permissions: [
      { key: 'pacientes:read', label: 'Ver pacientes' },
      { key: 'pacientes:create', label: 'Crear pacientes' },
      { key: 'pacientes:update', label: 'Editar pacientes' },
      { key: 'pacientes:delete', label: 'Borrar pacientes' },
    ],
  },
  {
    module: 'Pruebas y valoraciones',
    permissions: [
      { key: 'pruebas:read', label: 'Ver pruebas' },
      { key: 'pruebas:create', label: 'Crear pruebas' },
      { key: 'pruebas:update', label: 'Editar pruebas' },
      { key: 'pruebas:delete', label: 'Borrar pruebas' },
    ],
  },
  {
    module: 'Datos',
    permissions: [
      { key: 'datos:export', label: 'Exportar datos (Excel/CSV)' },
      { key: 'datos:import', label: 'Importar datos (CSV Encoder)' },
    ],
  },
  {
    module: 'Usuarios',
    permissions: [
      { key: 'users:read', label: 'Listar usuarios' },
      { key: 'users:create', label: 'Crear usuarios' },
      { key: 'users:update', label: 'Editar usuarios' },
      { key: 'users:activate', label: 'Activar / desactivar usuarios' },
      { key: 'users:manage_permissions', label: 'Gestionar permisos' },
      { key: 'users:manage_admins', label: 'Gestionar administradores' },
    ],
  },
];
